import React, { useContext } from 'react';
import { Col, Button } from '@thd-olt-component-react/core-ui';
import { PackagesMiniContext } from '../PackagesMiniContext';
import { TotalPrice } from './TotalPrice';
import { getPackageUrl } from '../../utils';
import './visual-package-summary.scss';

const VisualPackageSummary = () => {
  const { products, packageModel } = useContext(PackagesMiniContext);
  const packageUrl = getPackageUrl(packageModel);

  return (
    <>
      <Col className="visual-package-summary__total-price-container">
        <div className="visual-package-summary__total-price-text">{`Total Price for ${products.length} items`}</div>
        <TotalPrice products={products} isPackageVisual />
      </Col>
      <Col className="visual-package-summary__view-bundle-bttn-container">
        <Button outline tag="a" href={packageUrl} target="_self" data-testid="view-bundle-bttn-link">
          View Bundle
        </Button>
      </Col>
    </>
  );
};

VisualPackageSummary.displayName = 'VisualPackageSummary';

export { VisualPackageSummary };